import { render } from "./Ships.vue?vue&type=template&id=2a6a5731&scoped=true"
import script from "./Ships.vue?vue&type=script&lang=js"
export * from "./Ships.vue?vue&type=script&lang=js"

import "./Ships.vue?vue&type=style&index=0&id=2a6a5731&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6a5731"]])

export default __exports__